import { EmailScenario } from '../emailCustomization';
import { EmailTemplateType } from './email-template-type';
import { MandrillEmailTemplateType } from './mandrill-email-template-type';

export class EmailTemplate {
  id: string;
  scenario: EmailScenario;
  templateName: string; // email template name given for an email template in Admin => Email Templates
  templateType: EmailTemplateType;
  subject: string;
  content: string;
  contactName: string;
  contactEmail: string;
  mandrillTemplateName: MandrillEmailTemplateType; // Mandrill template name
  buttonText: string; // used in preview to render button
  buttonLink: string; // used in preview to render button link

  // NOTE: isDefault is not to be confused with isDefaultScenario.
  // isDefault indicates that an email template is set as default for the email template type/scenario combination
  isDefault: boolean;

  constructor(
    id: string,
    scenario: EmailScenario,
    templateName: string,
    templateType: EmailTemplateType,
    subject: string,
    content: string,
    contactName: string,
    contactEmail: string,
    isDefault: boolean,
    mandrillTemplateName: MandrillEmailTemplateType = null,
    buttonText: string = null,
    buttonLink: string = null
  ) {
    this.id = id;
    this.scenario = scenario;
    this.templateName = templateName;
    this.templateType = templateType;
    this.subject = subject;
    this.content = content;
    this.contactName = contactName;
    this.contactEmail = contactEmail;
    this.isDefault = isDefault;
    this.mandrillTemplateName = mandrillTemplateName;
    (this.buttonText = buttonText), (this.buttonLink = buttonLink);
  }

  static parse(obj: any): EmailTemplate {
    if (!obj) return;

    return new EmailTemplate(
      obj.id,
      obj.scenario,
      obj.templateName,
      obj.templateType,
      obj.subject,
      obj.content,
      obj.contactName,
      obj.contactEmail,
      obj.isDefault,
      obj.mandrillTemplateName,
      obj.buttonText,
      obj.buttonLink
    );
  }

  static empty(scenario: EmailScenario, templateType: EmailTemplateType) {
    return new EmailTemplate(null, scenario, null, templateType, null, null, null, null, false);
  }
}
